"use client";

import Image from "next/image";
import styles from "./index.module.scss";
import { MyLink } from "@/components/MyLink";
import { useRef } from "react";

export const BottomBanner = () => {
  const ref = useRef<HTMLDivElement>(null);
  const onClickClose = () => {
    if (!ref.current) return;
    ref.current.style.display = "none";
  };
  return (
    <div className={styles.bottomBanner} ref={ref}>
      <button onClick={onClickClose} aria-label="閉じる">
        <span>
          <span></span>
          <span></span>
        </span>
      </button>
      <div>
        <Image
          src="https://aisouken.blob.core.windows.net/banner/sidebar/AIsouken_banner_2.webp"
          width={300}
          height={300}
          alt="AI総合研究所　Bottom banner"
        />
        <div className={styles.texts}>
          <p>「すごくわかりやすい」と大好評！</p>
          <MyLink href="/resources">
            資料ダウンロード
          </MyLink>
        </div>
      </div>
    </div>
  );
};
